<template>
  <b-modal
    ref="load-more-modal"
    @hide="closeModal"
    centered
    hide-footer
    :title="`Searched term - ${search}`"
    size="md"
    no-close-on-backdrop
  >
    <div class="wrapper-prod">
      <div v-for="(prod, index) in prodData" :key="index">
        <b-row class="prod-container w-100 m-0">
          <b-col md="7" class="pl-0">
            <h6 class="m-0" v-text="prod.name" />
            <p class="text-muted m-0" v-text="prod.barcode" />
          </b-col>
          <b-col
            md="3"
            class="d-flex justify-content-center align-items-center"
          >
            <p class="m-0" v-text="currencySymbol + formatAmount(prod.mrp)" />
          </b-col>
          <b-col md="2" class="pr-0">
            <b-button
              variant="primary"
              :id="prod.barcode"
              @click="addToCart(prod)"
              :disabled="$loading"
            >
              Add
            </b-button>
          </b-col>
        </b-row>
      </div>
    </div>

    <b-pagination
      class="mb-0 mt-4"
      :class="[$loading ? 'opacity' : null]"
      v-model="pageNo"
      :total-rows="totalProd"
      :per-page="limit"
      :limit="6"
      pills
      @change="pageNumber"
      align="right"
      :disabled="$loading"
    />
  </b-modal>
</template>

<script>
import db from "../database";
import { mapState } from "vuex";
import axios from "axios";

export default {
  name: "show-search-products",
  props: ["open", "search", "totalProd", "limit"],
  data() {
    return {
      pageNo: 1,
      prodData: [],
    };
  },
  mounted() {
    db.searchedProducts.clear();
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    isSearchOnline() {
      let temp = true;
      if (this.state.system.hasOwnProperty("product_search_is_offline")) {
        if (this.state.system.product_search_is_offline == 1) temp = false;
      }
      return temp;
    },
  },
  watch: {
    open() {
      if (this.open) {
        if (!this.isSearchOnline) this.getOfflineProducts("load");
        else this.getOnlineProducts("load");
      } else this.$refs["load-more-modal"].hide();
    },
  },
  methods: {
    getOfflineProducts(where = "") {
      db.transaction("rw", db.products, db.searchedProducts, async () => {
        let products = await db.products
          .orderBy("barcode")
          .and((filter) => {
            return (
              filter.barcode
                .toLowerCase()
                .indexOf(this.search.toString().toLowerCase()) != -1 ||
              filter.name
                .toLowerCase()
                .indexOf(this.search.toString().toLowerCase()) != -1 ||
              (filter.category != null &&
                filter.category
                  .toLowerCase()
                  .indexOf(this.search.toString().toLowerCase()) != -1)
            );
          })
          .toArray();

        await db.searchedProducts.bulkPut(products);
      }).then(() => this.paginatedData(where));
    },
    paginatedData(where) {
      db.transaction("rw", db.searchedProducts, async () => {
        if (this.totalProd > this.limit) {
          this.prodData = await db.searchedProducts
            .offset(this.limit * this.pageNo - this.limit)
            .limit(this.limit)
            .toArray();
        } else this.prodData = await db.searchedProducts.toArray();
      }).then(() => {
        if (where == "load") this.$refs["load-more-modal"].show();
      });
    },
    getOnlineProducts(where = "") {
      this.$loading = true;
      let data = Object.assign(
        {
          search_term: this.search,
          limit: this.limit,
          url: "/product-search",
          page: this.pageNo,
        },
        this.essentialsData
      );

      axios
        .post(data.url, data)
        .then((res) => {
          this.prodData = res.data.data.data;
          this.$loading = false;
          if (where == "load") this.$refs["load-more-modal"].show();
        })
        .catch(() => (this.$loading = false));
    },
    pageNumber(e) {
      if (this.pageNo == e) return;

      this.pageNo = e;

      if (!this.isSearchOnline) this.paginatedData("page");
      else this.getOnlineProducts("page");
    },
    addToCart(item) {
      this.$emit("add-to-cart-more", item);
    },
    closeModal() {
      db.searchedProducts.clear();
      this.pageNo = 1;
      this.prodData = [];
      this.$emit("close-load-more-modal");
    },
  },
};
</script>

<style scoped lang="scss">
.wrapper-prod {
  height: 60vh;
  overflow: auto;
  @include custom-scrollbar();
}
.prod-container {
  padding: 15px 4px;
}
.theme-light {
  .prod-container {
    border-bottom: 1px solid $light-grey;
  }
}
.theme-dark {
  .prod-container {
    border-bottom: 1px solid #606060;
  }
  h6 {
    color: #c0c0c0;
  }
}
.opacity {
  opacity: 0.4;
}
</style>
